/* global axios */
import ApiClient from '../ApiClient';

class EnterpriseAccountAPI extends ApiClient {
  constructor() {
    super('', { accountScoped: true, enterprise: true });
  }

  checkout() {
    return axios.post(`${this.url}checkout`);
  }

  planCheckout(plan, interval = 'monthly', accountId) {
    return axios.post(this.memberUrl('plan_checkout', accountId), {
      plan,
      interval,
    });
  }

  planChangePreview(plan, interval = 'monthly', accountId) {
    return axios.post(this.memberUrl('plan_change_preview', accountId), {
      plan,
      interval,
    });
  }

  planUpgradeCheckout(plan, interval = 'monthly', accountId) {
    return axios.post(this.memberUrl('plan_upgrade_checkout', accountId), {
      plan,
      interval,
    });
  }

  planChange(plan, interval = 'monthly', accountId) {
    return axios.post(this.memberUrl('plan_change', accountId), { plan, interval });
  }

  cancelScheduledPlanChange(accountId) {
    return axios.post(this.memberUrl('cancel_scheduled_plan_change', accountId));
  }

  getPlans(accountId) {
    return axios.get(this.memberUrl('plans', accountId));
  }

  syncCheckout() {
    return axios.post(`${this.url}sync_checkout`);
  }

  subscription() {
    return axios.post(`${this.url}subscription`);
  }

  getLimits(accountId) {
    return axios.get(`${this.baseUrl(accountId)}/limits`);
  }

  toggleDeletion(action) {
    return axios.post(`${this.url}toggle_deletion`, {
      action_type: action,
    });
  }

  createTopupCheckout(credits) {
    return axios.post(`${this.url}topup_checkout`, { credits });
  }

  memberUrl(action, accountId) {
    return `${this.baseUrl(accountId)}/${action}`;
  }
}

export default new EnterpriseAccountAPI();
